import { schema } from 'normalizr';

export const shadeProportionSchema = new schema.Entity('shadeProportions', {}, { idAttribute: 'ShadeProportionId' });

export const shadeProportionListSchema = [shadeProportionSchema];
